<template>
  <div class="">
    <div class="flex items-center">
      <h4
        class="flex-shrink-0 pr-4  text-black font-bold tracking-tight md:text-lg text-base  uppercase"
      >
        Topics Covered
      </h4>
      <div class="flex-1 border-t-2 border-vectricYellow" />
    </div>
    <ul class="mt-6 lg:grid lg:grid-cols-2 lg:gap-x-2 lg:gap-y-4">
      <topic-grid-item
        v-for="(topic, idx) in session.topics"
        :topic="topic"
        :key="idx"
        :color="color"
      ></topic-grid-item>
    </ul>
  </div>
</template>

<script>
import TopicGridItem from "./TopicGridItem";

export default {
  name: "TopicGrid",
  props: {
    session: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: true,
      default: "text-darkBlue"
    }
  },
  components: {
    TopicGridItem
  }
};
</script>

<style scoped></style>
